export default __webpack_public_path__ + "static/media/cert-hr-cpttm.d6ec031c.jpg";